import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      setSettings(data);
      if (data?.seo?.title || data?.brand?.name) {
        document.title = data?.seo?.title || `${data.brand.name} ${data.brand.product_name}`;
      }
    }).catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={{ settings }}>
      {children}
    </SettingsContext.Provider>
  );
}
